import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = String(FIREBASE_CONFIG?.projectId || '').trim();

export async function updateClientProfile(docId, payload) {
  const docRef = doc(db, 'artifacts', appId, 'public', 'data', 'clients', docId);
  await updateDoc(docRef, { ...payload, updatedAt: serverTimestamp() });
}
